import request from '@/CommonDP/utils/request';

export default {
  // 上传插件，操作手册
  manualUpload(params) {
    return request.post('/admin/manual/upload', params);
  },

  // 插件
  queryPlugList(params) {
    return request.get(`/admin/manualPlug/plug/queryPlugList`, {
      params
    });
  },
  addPlug(params) {
    return request.post(`/admin/manualPlug/plug/addPlug`, params);
  },
  updatePlug(params) {
    return request.post(`/admin/manualPlug/plug/updatePlug`, params);
  },
  queryPlugDetail(id) {
    return request.get(
      `/admin/manualPlug/plug/queryPlugDetail?id=${id}`
    );
  },
  queryPlugEnable(id) {
    return request.get(`/admin/manualPlug/plug/enable?id=${id}`);
  },
  queryPlugDisable(id) {
    return request.get(`/admin/manualPlug/plug/disable?id=${id}`);
  },

  // 帮助手册
  queryManualList(params) {
    return request.get(`/admin/manualPlug/manual/queryManualList`, {
      params
    });
  },
  addManual(params) {
    return request.post(`/admin/manualPlug/manual/addManual`, params);
  },
  queryManualDetail(id) {
    return request.get(
      `/admin/manualPlug/manual/queryManualDetail?id=${id}`
    );
  },
  updateManual(params) {
    return request.post(`/admin/manualPlug/manual/updateManual`, params);
  },
  queryManualEnable(id) {
    return request.get(`/admin/manualPlug/manual/enable?id=${id}`);
  },
  queryManualDisable(id) {
    return request.get(`/admin/manualPlug/manual/disable?id=${id}`);
  }
};
